import { render, staticRenderFns } from "./ClientCarrier.vue?vue&type=template&id=3b646a4f&scoped=true"
import script from "./ClientCarrier.vue?vue&type=script&lang=js"
export * from "./ClientCarrier.vue?vue&type=script&lang=js"
import style0 from "./ClientCarrier.vue?vue&type=style&index=0&id=3b646a4f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b646a4f",
  null
  
)

export default component.exports